import inicialState from './recebimento.state';
import * as actions from './recebimento.action';

const recebimentoReducer = (state = inicialState, action) => {
  switch (action.type) {
    case actions.ALTERAR_MEDICO_EXECUTANTE:
      return {
        ...state,
        medicoExecutante: action.payload.medicoExecutante,
      };

    default:
      return state;
  }
};

export default recebimentoReducer;



// WEBPACK FOOTER //
// ./src/pages/configuracao/tab/material/recebimento.reducer.js